export default __webpack_public_path__ + "static/media/umrah_camp_photo_(1)[1].79b228bc.png";